
import {countries} from '@/constants'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countries,
      phoneNumber: '',
      selectedCountry: countries.us,
      showOptions: false,
      validationError: null,
      validationMessage: '',
      firstInput: true
    }
  },
  watch: {
    phoneNumber: function (value) {
      const onlyNumber = /^\d+$/
      if (this.firstInput) {
        this.phoneNumber = '+' + this.selectedCountry.dialCode + value
        this.firstInput = false
      } else {
        let beautifiedNumber = '+' + this.selectedCountry.dialCode
        let withoutPlus = value.slice(1)
        if (value.length <= 1) {
          this.validationError = true
          this.validationMessage = `Phone number must start with: ${beautifiedNumber}`
          this.$emit('validNumber', false)
        } else if (
            value.startsWith(beautifiedNumber, 0)
            && (value.length === this.selectedCountry.length)
            && onlyNumber.test(withoutPlus)
        ) {
          this.validationError = false
          this.validationMessage = ''
          this.$emit('validNumber', true)
        } else {
          this.validationError = true
          this.validationMessage = "Phone number is incorrect"
          this.$emit('validNumber', false)
        }
      }
    }
  },
  methods: {
    showDropdown() {
      this.showOptions = !this.showOptions
    },
    getFlagImage(fileName) {
      return require(`@/assets/img/flags/${fileName}`)
    },
    handleCountryChange(country) {
      this.validationError = null;
      this.selectedCountry = country
      this.phoneNumber = ''
      this.firstInput = true
      this.showDropdown()
    },
  },
}
